module.exports = __webpack_public_path__ + "img/preset4.d4be9887.png";